// Helper to safely format image URLs
export const getAssetUrl = (pathString) => {
  if (!pathString) return '';
  // If the path is already a full blob URL (local preview), return it directly
  if (pathString.startsWith('blob:')) return pathString;

  // Retrieve base url from your build environment configurations
  const baseUrl = process.env?.REACT_APP_API_BASE_URL;
  
  // Combines base (e.g. http://localhost:5000) with path (e.g. /uploads/image.jpg)
  return `${baseUrl}${pathString}`;
};
